import script from "./ConsumerMypageProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerMypageProfileView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerMypageProfileView.vue?vue&type=style&index=0&id=6ec988da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec988da"]])

export default __exports__